import { App } from '../models/app.model';

const tag = '[App]';

export class FetchAppsRequest {
  static readonly type = `${tag} fetch apps request`;
}

export class FetchAppsSuccess {
  static readonly type = `${tag} fetch apps success`;
  constructor(public apps: App[]) {}
}

export class FetchAppsError {
  static readonly type = `${tag} fetch apps error`;
}

export class FetchAppsEmptyError {
  static readonly type = `${tag} fetch apps empty error`;
}

export class SetCurrentApp {
  static readonly type = `${tag} set current app`;
  constructor(public appId: number) {}
}

export class UpdateAvailable {
  static readonly type = `${tag} service worker update available`;
}

export class ResetAppState {
  static readonly type = `${tag} reset app state`;
}

export class ResetCurrentApp {
  static readonly type = `${tag} reset current app`;
}

export class UnlockUpdateRequest {
  static readonly type = `${tag} unlock update request`;
}

export class UnlockUpdateSuccess {
  static readonly type = `${tag} unlock update success`;
}

export class UnlockUpdateError {
  static readonly type = `${tag} unlock update error`;
}
